import { render } from "./sel-icon.vue?vue&type=template&id=15f14085&scoped=true"
import script from "./sel-icon.vue?vue&type=script&lang=js"
export * from "./sel-icon.vue?vue&type=script&lang=js"

import "./sel-icon.vue?vue&type=style&index=0&id=15f14085&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f14085"]])

export default __exports__